<div class="attributes-selector-container">
  <div class="search-container">
    <form [formGroup]="searchForm" class="hide-subscript">
      <mat-form-field appearance="outline" class="full-width">
        <input
          matInput
          formControlName="searchText"
          [placeholder]="T_SCOPE + '.search-placeholder' | translate"
        />
      </mat-form-field>
    </form>
  </div>

  <div class="horizontal-separator"></div>

  <div class="all-search-groups">
    <!-- Search results -->
    <div class="search-groups">
      <div *ngFor="let group of searchGroups">
        <mat-expansion-panel
          [expanded]="expandedGroups[group.groupId]"
          class="custom-expansion-panel compact-selector-expansion-panel"
        >
          <mat-expansion-panel-header>
            <div class="custom-panel-header">{{ group.label$ | async }}</div>
          </mat-expansion-panel-header>

          <div class="group-elements">
            <cdk-virtual-scroll-viewport class="group-elements-viewport" [itemSize]="itemSize">
              <div
                *cdkVirtualFor="let item of group.items"
                class="element-row"
                [class.measurement-row]="item.itemType === SearchResultItemType.Measurement"
              >
                <mat-radio-button
                  *ngIf="item.itemType === SearchResultItemType.AttributeResult"
                  class="custom-radio-button"
                  [checked]="selectedSearchItem?.resultId === item.resultId"
                  (change)="setSelectedSearchItem(item)"
                ></mat-radio-button>
                <wlm-icon *ngIf="item.icon" [icon]="item.icon"></wlm-icon>
                <div class="element-info">
                  <div class="element-id">{{ item.label$ | async }}</div>
                  <div *ngIf="item.breadcrumbs$" class="item-breadcrumbs">
                    {{ item.breadcrumbs$ | async }}
                  </div>
                </div>
                <button
                  *ngIf="item.itemType === SearchResultItemType.Measurement"
                  mat-icon-button
                  (click)="onAddMeasurementToCart(item)"
                >
                  <wlm-icon [icon]="'add'"></wlm-icon>
                </button>
              </div>
            </cdk-virtual-scroll-viewport>
            <span class="horizontal-separator"></span>
          </div>
        </mat-expansion-panel>
      </div>
    </div>

    <div class="horizontal-separator"></div>

    <!-- Attribute Results Panel -->
    <mat-expansion-panel
      class="custom-expansion-panel compact-selector-expansion-panel"
      [expanded]="attributesExpanded"
    >
      <mat-expansion-panel-header>
        <div class="custom-panel-header">{{ T_SCOPE + '.attribute-results' | translate }}</div>
      </mat-expansion-panel-header>

      <div class="select-all-container" *ngIf="attributeResults.length">
        <mat-checkbox [(ngModel)]="selectAllAttributes" (change)="toggleSelectAll()">
          {{ T_SCOPE + '.select-all' | translate }}
        </mat-checkbox>
      </div>

      <div class="group-elements attribute-results">
        <cdk-virtual-scroll-viewport class="group-elements-viewport" [itemSize]="itemSize">
          <div *cdkVirtualFor="let attr of attributeResults" class="attribute-row">
            <mat-checkbox
              class="custom-checkbox"
              [ngModel]="isAttributeChecked(attr)"
              (ngModelChange)="onCheckboxChange(attr, $event)"
              [disabled]="isAttributeInCart(attr)"
            ></mat-checkbox>
            <wlm-icon *ngIf="attr.icon" [icon]="attr.icon"></wlm-icon>
            <div class="attribute-info">
              <div class="attribute-name">{{ attr.attributeAlias || attr.attributeName }}</div>
              <div class="item-breadcrumbs">{{ attr.breadcrumbs$ | async }}</div>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </mat-expansion-panel>
  </div>

  <div class="cart-button-container">
    <button mat-button [disabled]="!selectedAttributes.length" (click)="onAddAttributesToCart()">
      {{ T_SCOPE + '.add-to-cart' | translate }}
    </button>
  </div>
</div>
